<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup></script>

<style>
html,
body {
  overflow: hidden !important;
  width: 100%;
  height: 100%;
}
@media print {
  html,
  body {
    overflow: auto;
    width: 100%;
    height: auto;
  }
}

.back.white {
  background-color: #ffffff;
}

.back.orange.dark {
  background-color: #d2620e;
}
.text.orange.dark {
  color: #d2620e;
}
.borderOrange {
  border-color: #d2620e !important;
}
.svgOrange {
  filter: brightness(0) saturate(100%) invert(36%) sepia(68%) saturate(1307%) hue-rotate(360deg)
    brightness(99%) contrast(91%);
}

.border1 {
  border: 1px solid;
}

.colorAlle {
  color: #777;
}
.borderAlle {
  border-color: #777 !important;
}
.backAlle {
  background-color: #777;
}
.svgAlle {
  filter: brightness(0) saturate(100%) invert(53%) sepia(8%) saturate(17%) hue-rotate(11deg)
    brightness(86%) contrast(84%);
}

.colorTotholz {
  color: #8b623a;
}
.borderTotholz {
  border-color: #8b623a !important;
}
.backTotholz {
  background-color: #8b623a;
}
.svgTotholz {
  filter: brightness(0) saturate(100%) invert(39%) sepia(31%) saturate(693%) hue-rotate(349deg)
    brightness(96%) contrast(91%);
}

.colorBaumartenvielfalt {
  color: #6b912e;
}
.borderBaumartenvielfalt {
  border-color: #6b912e !important;
}
.backBaumartenvielfalt {
  background-color: #6b912e;
}
.svgBaumartenvielfalt {
  filter: brightness(0) saturate(100%) invert(48%) sepia(21%) saturate(1263%) hue-rotate(41deg)
    brightness(101%) contrast(85%);
}

.colorStruktur {
  color: #447681;
}
.borderStruktur {
  border-color: #447681 !important;
}
.backStruktur {
  background-color: #447681;
}
.svgStruktur {
  filter: brightness(0) saturate(100%) invert(44%) sepia(23%) saturate(681%) hue-rotate(143deg)
    brightness(91%) contrast(93%);
}

.colorHabitate {
  color: #e38007;
}
.borderHabitate {
  border-color: #e38007 !important;
}
.backHabitate {
  background-color: #e38007;
}
.svgHabitate {
  filter: brightness(0) saturate(100%) invert(67%) sepia(38%) saturate(5974%) hue-rotate(1deg)
    brightness(92%) contrast(94%);
}

.colorProzessschutz {
  color: #88528b;
}
.borderProzessschutz {
  border-color: #88528b !important;
}
.backProzessschutz {
  background-color: #88528b;
}
.svgProzessschutz {
  filter: brightness(0) saturate(100%) invert(41%) sepia(20%) saturate(1196%) hue-rotate(249deg)
    brightness(84%) contrast(84%);
}

.markdown a {
  color: #d2620e !important;
  text-decoration: underline;
}

.markdown ol {
  padding-left: 1em;
  margin-bottom: 10px;
}

.markdown ul {
  padding-left: 1em;
  margin-bottom: 10px;
}

.downloadsMarkdown a {
  display: inline-block;
  padding-left: 24px;
  background-image: URL(/file-outline.svg);
  background-size: 16px auto;
  color: black;
  text-decoration: none;
}

.markdown.headersTotholz h2,
.markdown.headersTotholz h3,
.markdown.headersTotholz h4 {
  color: #8b623a !important;
}

.markdown.headersBaumartenvielfalt h2,
.markdown.headersBaumartenvielfalt h3,
.markdown.headersBaumartenvielfalt h4 {
  color: #6b912e !important;
}

.markdown.headersStruktur h2,
.markdown.headersStruktur h3,
.markdown.headersStruktur h4 {
  color: #447681 !important;
}

.markdown.headersHabitate h2,
.markdown.headersHabitate h3,
.markdown.headersHabitate h4 {
  color: #e38007 !important;
}

.markdown.headersProzessschutz h2,
.markdown.headersProzessschutz h3,
.markdown.headersProzessschutz h4 {
  color: #88528b !important;
}
</style>
